import * as React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import { Button, Typography, makeStyles } from '@material-ui/core';

import * as PatientStore from '../../../app/store/PatientStore';

const useStyles = makeStyles(theme => ({
    root: {
    },
    actions: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1),
        display: 'flex',
        justifyContent: 'flex-end',
    },
    addIcon: {
        marginRight: theme.spacing(1),
    },
    divider: {
        marginTop: theme.spacing(1),
    },
    currentCode: {
        margin: theme.spacing(4),
        display: 'flex',
        justifyContent: 'center',
        textTransform: 'uppercase',
    },
    deleteButton: {
        color: theme.palette.error.main,
    },
}));

const EditStudentAccessCode = ({ patientId, programData }) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const translate = useSelector(state => getTranslate(state.localize));

    const generateNewCode = () => {
        dispatch(PatientStore.actionCreators.generateNewAccessCode(programData.id, {
            // callback: onClose,
            reducerParams: { patientId },
        }));
    };

    const removeCode = () => {
        dispatch(PatientStore.actionCreators.removeAccessCode(programData.id, {
            // callback: onClose,
            reducerParams: { patientId },
        }));
    };

    if (!programData) {
        return null;
    }

    return (
        <div className={classes.root}>
            <Typography>
                {translate('student.accessCodeDescription')}
            </Typography>

            {programData.accessCode ? (
                <div className={classes.currentCode}>
                    <Typography variant="h3">
                        {programData.accessCode}
                    </Typography>
                </div>
            ) : (
                <Typography color="textSecondary" className={classes.currentCode}>
                    {translate('student.noAccessCodeRegistered')}
                </Typography>
            )}

            <div className={classes.actions}>
                {programData.accessCode ? (
                    <Button variant="outlined" className={classes.deleteButton} onClick={removeCode}>
                        {translate('student.removeAccessCode')}
                    </Button>
                ) : (
                    <Button variant="contained" color="secondary" onClick={generateNewCode}>
                        {translate('student.generateNewAccessCode')}
                    </Button>
                )}
            </div>

        </div>
    );
};

EditStudentAccessCode.propTypes = {
    patientId: PropTypes.string.isRequired,
    programData: PropTypes.object.isRequired,
    // onClose: PropTypes.func.isRequired,
};

export default EditStudentAccessCode;
